(function() {
  // available filter set
  // document.querySelectorAll(".facets_summary").forEach((filter)=>{
  //   filter.addEventListener("click",function(event){
  //     setTimeout(()=>{

  //     window.location = `${location.origin}/${location.pathname}?${location.search}&filter.v.availability=1`;
  //     },700)
  //   })
  // })

   // static bar button event
  let staticBarButton = document.querySelector(".js-static-bar-button");
  staticBarButton ? staticBarButton.addEventListener("click",function(){
    document.querySelector("[name=add]").click();
  }) : '';
  
    let sortButton = document.querySelector(".js-show-sort");

    let sizeFills = document.querySelectorAll(".js-size-fill");
    let scentFills = document.querySelectorAll(".js-scent-fill");
    let sizeResult = document.querySelector(".js-size-result");
    let scentResult = document.querySelector(".js-scent-result");
    let sortContent = document.querySelector(".js-sort-content");
    if (sortButton || sortContent) {
        sortButton.addEventListener("click", function(event) {
            setTimeout(() => {
                let sortContent = document.querySelector(".js-sort-content");
                event.target.closest('.sort_fill').classList.toggle("active");
                sortContent.classList.toggle("hidden");
                sortContent.classList.toggle("active");
                scentFills.length > 0 && scentFills[1].classList.contains('active') == true ? scentFills[1].classList.remove('active') : '';
                sizeFills.length > 0  && sizeFills[1].classList.contains('active') == true ? sizeFills[1].classList.remove('active') : '';
                sortContent.classList.contains("active") == false ? document.querySelector(".js-filter-result-main").classList.add("no_filter_active") : document.querySelector(".js-filter-result-main").classList.remove("no_filter_active");
            }, 500);

            sizeResult ? sizeResult.classList.add("hidden") : '';
            sizeResult ? sizeResult.classList.remove("active") : '';
            scentResult ? scentResult.classList.add("hidden") : '';
            scentResult ? scentResult.classList.remove("active") : '';
        });
    }

    if (sizeFills.length > 0 || sizeResult || scentFills.length > 0 || scentResult) {
      sizeFills.forEach((sizeFill)=>
        sizeFill.addEventListener("click", function(event) {
            event.target.closest('.js-size-fill').classList.toggle("active");
            sizeResult ? sizeResult.classList.toggle("hidden") : '';
            sizeResult ? sizeResult.classList.toggle("active") : '';
            sizeResult && sizeResult.classList.contains("active") == false ? document.querySelector(".js-filter-result-main").classList.add("no_filter_active") : document.querySelector(".js-filter-result-main").classList.remove("no_filter_active");
            sortContent.classList.add("hidden");
            sortContent.classList.remove("active");
            scentResult ? scentResult.classList.add("hidden") : '';
            scentFills.length > 0 && scentFills[1].classList.contains('active') == true ? scentFills[1].classList.remove('active') : '';
            sortButton.closest('.sort_fill').classList.contains('active') == true ? sortButton.closest('.sort_fill').classList.remove('active') : '';
            scentResult ? scentResult.classList.remove("active") : '';
        }));
        if(scentFills.length > 0) {
          scentFills.forEach((scentFill)=>
            scentFill.addEventListener("click", function() {
            event.target.closest('.js-scent-fill').classList.toggle("active");
            scentResult ? scentResult.classList.toggle("hidden") : '';
            scentResult ? scentResult.classList.toggle("active") : '';
            scentResult && scentResult.classList.contains("active") == false ? document.querySelector(".js-filter-result-main").classList.add("no_filter_active") : document.querySelector(".js-filter-result-main").classList.remove("no_filter_active");
            sizeResult ? sizeResult.classList.add("hidden") : '';
            sizeResult ? sizeResult.classList.remove("active") : '';
            sizeFills.length > 0 && sizeFills[1].classList.contains('active') == true ? sizeFills[1].classList.remove('active') : '';
            sortButton.closest('.sort_fill').classList.contains('active') == true ? sortButton.closest('.sort_fill').classList.remove('active') : '';
            sortContent.classList.add("hidden");
            sortContent.classList.remove("active");
        }))
        } ;
    }

    
    // sort by selected show on sort by tab

    window.addEventListener("load", (event) => {
        let locationValue = location.search
        if (locationValue != null && locationValue.includes("sort_by") == true) {
            document.querySelector(".js-sort-content").querySelectorAll("input").forEach((v) => {
                if (v.hasAttribute("checked") == true) {
                    document.querySelector(".js-show-sort").querySelector("span").innerText = v.getAttribute("data-label-value");
                }
            })
        }
      if(document.querySelector("body").classList.contains("template-product") == true){
        setTimeout(()=>{
          document.querySelector(".product-grid-img-desk").classList.add("show");
        },200)
      }
    });

    // load more functionality

    // window._handleLoadMoreClick = function _handleLoadMoreClick(evt) {
    //     console.log(evt);
    //     let loadMoreBtn = evt.currentTarget;
    //     loadMoreBtn.setAttribute("disabled", true);
    //     loadMoreBtn.setAttribute("loading", true);
    //     loadMoreBtn.querySelector(".js-more-text").classList.add("hidden");
    //     loadMoreBtn.querySelector(".js-loading-text").classList.remove("hidden");
    //     let totalPages = parseInt(loadMoreBtn.closest(".shopify-section").querySelector("[data-total-pages]").value);
    //     let currentPage = parseInt(loadMoreBtn.closest(".shopify-section").querySelector("[data-current-page]").value);
    //     currentPage = currentPage + 1;
    //     loadMoreBtn.closest(".shopify-section").querySelector("[data-current-page]").value = currentPage;
    //     let currentItemCount = parseInt(loadMoreBtn.getAttribute("current-grid-size")) ;
    //     let totalItemCount = parseInt(loadMoreBtn.getAttribute("data-items"));
    //     let newProductCount = 24;
    //     let nextPageURL = loadMoreBtn.closest(".shopify-section").querySelector('[data-next-url]').value.replace(/page=[0-9]+/, 'page=' + currentPage)
    //     fetch(nextPageURL, { method: "GET", headers: { "Content-type": "application/json; charset=UTF-8" } })
    //         .then(res => res.text())
    //         .then((response) => {
    //             //console.log(response);
    //             let parser = new DOMParser();
    //             let newHtml = parser.parseFromString(response, "text/html");
    //             if (loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#product-grid")) {
    //                 loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#product-grid").insertAdjacentHTML("beforeend", newHtml.querySelector("#Huratips-Loop").querySelector("#product-grid").innerHTML);
                   
    //             } else {
    //                 // loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#article-grid").insertAdjacentHTML("beforeend", newHtml.querySelector("#Huratips-Loop").querySelector("#article-grid").innerHTML);
    //                  // For blog articles
    //                   let existingArticleGrid = loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#article-grid");
    //                   let newArticleHTML = newHtml.querySelector("#Huratips-Loop").querySelector("#article-grid").innerHTML;
                      
    //                   // Store existing article count before adding new ones
    //                   let existingArticleCount = existingArticleGrid.querySelectorAll(".blog-articles__article").length;
                      
    //                   // Insert new articles
    //                   existingArticleGrid.insertAdjacentHTML("beforeend", newArticleHTML);
                      
    //                   // Remove duplicates if any exist
    //                   let allArticles = existingArticleGrid.querySelectorAll(".blog-articles__article");
    //                   let articleUrls = new Set();
    //                   let duplicates = [];
                      
    //                   allArticles.forEach((article, index) => {
    //                       let articleLink = article.querySelector("a.full-unstyled-link");
    //                       if (articleLink) {
    //                           let url = articleLink.getAttribute("href");
    //                           if (articleUrls.has(url)) {
    //                               duplicates.push(article);
    //                           } else {
    //                               articleUrls.add(url);
    //                           }
    //                       }
    //                   });
                      
    //                   // Remove duplicate articles
    //                   duplicates.forEach(duplicate => duplicate.remove());
                   
    //             }
    //             loadMoreBtn.removeAttribute("loading");
    //             loadMoreBtn.querySelector(".js-more-text").classList.remove("hidden");
    //             loadMoreBtn.querySelector(".js-loading-text").classList.add("hidden");
                
                
    //             currentItemCount = currentItemCount + 24;
    //             currentItemCount = currentItemCount > totalItemCount ? totalItemCount : currentItemCount;
    //             console.log(currentItemCount,"currentItemCountcurrentItemCount")
    //             loadMoreBtn.setAttribute("current-grid-size",currentItemCount);
    //             document.querySelector("#ProductCount") ? document.querySelector("#ProductCount").innerText = currentItemCount : '';
    //             document.querySelector(".js-product-count-spn") ? document.querySelector(".js-product-count-spn").innerText = `${currentItemCount} products results` : '';
                
    //             let blogCount = 24;
    //             // if(document.querySelectorAll(".blog-articles__article").length > 0){
                  
    //             //  for (let i = blogCount + 1; i <= currentItemCount; i++)
    //             //   {
    //             //     document.querySelectorAll(".blog-articles__article")[i - 1].classList.add(`blog_article_count__${i}`);
                    
                    
    //             //     // count is only evaluated once and then the comparison is always on 0.
    //             //   }
    //             // }
    //             if (document.querySelectorAll(".blog-articles__article").length > 0) {
    //               let allBlogArticles = document.querySelectorAll(".blog-articles__article");
                  
    //               allBlogArticles.forEach((article, index) => {
    //                   const articleNumber = index + 1;
    //                   // Remove any existing blog_article_count__ class first
    //                   article.classList.forEach(className => {
    //                       if (className.startsWith('blog_article_count__')) {
    //                           article.classList.remove(className);
    //                       }
    //                   });
    //                   // Add the correct class
    //                   article.classList.add(`blog_article_count__${articleNumber}`);
    //               });
                  
    //               // Update currentItemCount to match actual article count
    //               currentItemCount = allBlogArticles.length;
    //               loadMoreBtn.setAttribute("current-grid-size", currentItemCount);
    //           }
                  
    //            if (loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#product-grid")) {
    //                document.querySelector(".js-count-text") ? document.querySelector(".js-count-text").innerHTML = `You've viewed ${currentItemCount} of ${totalItemCount} products` : '';
    //              document.querySelector(".js-travel-product") ? document.querySelector(".js-travel-product").innerHTML = `${currentItemCount} fragrances to choose from` : '';
    //            } else{

    //                document.querySelector(".js-count-text").innerHTML = `You've viewed ${currentItemCount} of ${totalItemCount} articles`
    //            }  
    //             if (currentPage <= totalPages) {
    //                 loadMoreBtn.removeAttribute('disabled');
    //             }
    //             if (currentPage == totalPages) {
    //                 // loadMoreBtn.closest(".shopify-section").querySelector(".pagination-wrapper").classList.add("hide");
    //                 loadMoreBtn.closest(".load-more_wrap").classList.add("hidden");
    //                loadMoreBtn.closest(".shopify-section").querySelector("#product-grid")?loadMoreBtn.closest(".shopify-section").querySelector("#product-grid").classList.add("tw-mb-8") : "";
    //               loadMoreBtn.closest(".shopify-section").querySelector("#article-grid")?loadMoreBtn.closest(".shopify-section").querySelector("#article-grid").classList.add("tw-mb-8") : "";
    //             }
    //             if(document.querySelector(".js-travel-spray-section")){
  
    //               window.travelSprayBundle.init();
    //             }
    //           if(document.querySelector(".js-sample-bundle-section")){
    //             window.sampleCollectionBundle.init();
    //           }
    //           if(document.querySelector(".js-refill-bundle")){
    //               window.refillBundle.init();
    //           }
    //             let newQuickViewaBtns = document.querySelectorAll(".js-pro-cart-button");
    //             newQuickViewaBtns.forEach((newQuickViewaBtn) => {
    //               newQuickViewaBtn.addEventListener("click",(e)=>{
    //                 let quickViewDiv = e.target.closest(".card--standard").querySelector(".quick-add").querySelector(".quick-add__submit");
    //                 console.log(quickViewDiv)
    //                 quickViewDiv.click();
    //               })
    //             })
    //             // QuickShop.prototype.bindBtnEvents();
    //             // window._bindCollectionEvents();
    //             // document.dispatchEvent(new CustomEvent('swym:collections-loaded', { bubbles: true }));
    //         });
    // }

    // window._bindLoadMoreEvents = function _bindLoadMoreEvents() {
      
    //     let loadMoreButtons = document.querySelectorAll(".js-load-more");
    //     loadMoreButtons.forEach((loadMoreButton) => {
    //         console.log(loadMoreButton);
    //         loadMoreButton.addEventListener("click", window._handleLoadMoreClick.bind(this), true);
    //     });
    // }
    // _bindLoadMoreEvents();


    // ===== ADD (global, do NOT move inside function) =====
window._articleBuffer = window._articleBuffer || [];
const ARTICLES_PER_CLICK = 24;
// ====================================================

window._handleLoadMoreClick = function _handleLoadMoreClick(evt) {
    console.log(evt);
    let loadMoreBtn = evt.currentTarget;
    let section = loadMoreBtn.closest(".shopify-section");

    let isProductGrid = section.querySelector("#product-grid");
    let isArticleGrid = section.querySelector("#article-grid");

    loadMoreBtn.setAttribute("disabled", true);
    loadMoreBtn.setAttribute("loading", true);
    loadMoreBtn.querySelector(".js-more-text").classList.add("hidden");
    loadMoreBtn.querySelector(".js-loading-text").classList.remove("hidden");

    let totalPages = parseInt(section.querySelector("[data-total-pages]").value);
    let currentPage = parseInt(section.querySelector("[data-current-page]").value);
    currentPage = currentPage + 1;
    section.querySelector("[data-current-page]").value = currentPage;

    let currentItemCount = parseInt(loadMoreBtn.getAttribute("current-grid-size"));
    let totalItemCount = parseInt(loadMoreBtn.getAttribute("data-items"));

    let nextPageURL = section
        .querySelector('[data-next-url]')
        .value.replace(/page=[0-9]+/, 'page=' + currentPage);

    fetch(nextPageURL, {
        method: "GET",
        headers: { "Content-type": "application/json; charset=UTF-8" }
    })
    .then(res => res.text())
    .then((response) => {
        let parser = new DOMParser();
        let newHtml = parser.parseFromString(response, "text/html");

        // ================= PRODUCT GRID (UNCHANGED) =================
        if (isProductGrid) {
            section
                .querySelector("#Huratips-Loop")
                .querySelector("#product-grid")
                .insertAdjacentHTML(
                    "beforeend",
                    newHtml
                        .querySelector("#Huratips-Loop")
                        .querySelector("#product-grid")
                        .innerHTML
                );
        }
        // =============================================================

        // ================= ARTICLE GRID (24 ONLY, NO SKIP) ===========
        if (isArticleGrid) {
            let existingArticleGrid = section
                .querySelector("#Huratips-Loop")
                .querySelector("#article-grid");

            let incomingArticles = Array.from(
                newHtml
                    .querySelector("#Huratips-Loop")
                    .querySelector("#article-grid")
                    .children
            );

            // Add fetched articles to buffer
            window._articleBuffer = window._articleBuffer.concat(incomingArticles);

            // Render only 24
            let toRender = window._articleBuffer.splice(0, ARTICLES_PER_CLICK);

            toRender.forEach(article => {
                existingArticleGrid.appendChild(article);
            });

            // ---- Duplicate protection (your existing logic kept) ----
            let allArticles = existingArticleGrid.querySelectorAll(".blog-articles__article");
            let articleUrls = new Set();
            let duplicates = [];

            allArticles.forEach(article => {
                let articleLink = article.querySelector("a.full-unstyled-link");
                if (articleLink) {
                    let url = articleLink.getAttribute("href");
                    if (articleUrls.has(url)) {
                        duplicates.push(article);
                    } else {
                        articleUrls.add(url);
                    }
                }
            });

            duplicates.forEach(duplicate => duplicate.remove());
        }
        // =============================================================

        loadMoreBtn.removeAttribute("loading");
        loadMoreBtn.querySelector(".js-more-text").classList.remove("hidden");
        loadMoreBtn.querySelector(".js-loading-text").classList.add("hidden");

        // ================= COUNT HANDLING =================
        if (isProductGrid) {
            currentItemCount = section.querySelectorAll("#product-grid .grid__item").length;
        }

        if (isArticleGrid) {
            let allBlogArticles = document.querySelectorAll(".blog-articles__article");

            allBlogArticles.forEach((article, index) => {
                const articleNumber = index + 1;
                article.classList.forEach(className => {
                    if (className.startsWith('blog_article_count__')) {
                        article.classList.remove(className);
                    }
                });
                article.classList.add(`blog_article_count__${articleNumber}`);
            });

            currentItemCount = allBlogArticles.length;
        }

        currentItemCount = currentItemCount > totalItemCount
            ? totalItemCount
            : currentItemCount;

        loadMoreBtn.setAttribute("current-grid-size", currentItemCount);

        document.querySelector("#ProductCount")
            ? document.querySelector("#ProductCount").innerText = currentItemCount
            : '';

        document.querySelector(".js-product-count-spn")
            ? document.querySelector(".js-product-count-spn").innerText =
                `${currentItemCount} products results`
            : '';

        if (isProductGrid) {
            document.querySelector(".js-count-text")
                ? document.querySelector(".js-count-text").innerHTML =
                    `You've viewed ${currentItemCount} of ${totalItemCount} products`
                : '';

            document.querySelector(".js-travel-product")
                ? document.querySelector(".js-travel-product").innerHTML =
                    `${currentItemCount} fragrances to choose from`
                : '';
        } else {
            document.querySelector(".js-count-text").innerHTML =
                `You've viewed ${currentItemCount} of ${totalItemCount} articles`;
        }

        if (currentPage <= totalPages) {
            loadMoreBtn.removeAttribute('disabled');
        }

        if (currentPage == totalPages) {
            loadMoreBtn.closest(".load-more_wrap").classList.add("hidden");
            section.querySelector("#product-grid")
                ? section.querySelector("#product-grid").classList.add("tw-mb-8")
                : "";
            section.querySelector("#article-grid")
                ? section.querySelector("#article-grid").classList.add("tw-mb-8")
                : "";
        }

        if (document.querySelector(".js-travel-spray-section")) {
            window.travelSprayBundle.init();
        }
        if (document.querySelector(".js-sample-bundle-section")) {
            window.sampleCollectionBundle.init();
        }
        if (document.querySelector(".js-refill-bundle")) {
            window.refillBundle.init();
        }

        let newQuickViewaBtns = document.querySelectorAll(".js-pro-cart-button");
        newQuickViewaBtns.forEach((newQuickViewaBtn) => {
            newQuickViewaBtn.addEventListener("click", (e) => {
                let quickViewDiv = e.target
                    .closest(".card--standard")
                    .querySelector(".quick-add")
                    .querySelector(".quick-add__submit");
                quickViewDiv.click();
            });
        });
    });
};

window._bindLoadMoreEvents = function _bindLoadMoreEvents() {
    let loadMoreButtons = document.querySelectorAll(".js-load-more");
    loadMoreButtons.forEach((loadMoreButton) => {
        console.log(loadMoreButton);
        loadMoreButton.addEventListener(
            "click",
            window._handleLoadMoreClick.bind(this),
            true
        );
    });
};

_bindLoadMoreEvents();


    // Video open in popup
    const videoPopup = document.getElementById('videoPopup');
    const closePopupBtn = document.getElementById('closePopup');
    const iframe = document.getElementById('player');
    const src = videoPopup ? videoPopup.getAttribute("data-src") : '';
     document.querySelectorAll(".video-button").length > 0 ? document.querySelectorAll(".video-button").forEach((button)=>{
        button.addEventListener("click",function(e){
          // Open popup and autoplay video
          videoPopup.style.display = 'flex';
          iframe.src = `${src}&autoplay=1`;
          document.querySelector("body").classList.add("scroll-lock");
        })
     }): '';
    // Close popup
    closePopupBtn ? closePopupBtn.addEventListener('click', function() {
      videoPopup.style.display = 'none';
      iframe.src = ''; // Stop video when popup is closed
      document.querySelector("body").classList.remove("scroll-lock");
    }) : '';
  
    // Close popup when clicking outside the iframe
   videoPopup ? videoPopup.addEventListener('click', function(event) {
      if (event.target === videoPopup) {
        videoPopup.style.display = 'none';
        iframe.src = ''; // Stop video when popup is closed
        document.querySelector("body").classList.remove("scroll-lock");
      }
    }) : "";
  
    

    // Product page tab scroll

    // sticky bar on scroll
    document.addEventListener('scroll', function(e) {
      if(document.querySelector(".main-product-inner") && window.scrollY >= document.querySelector(".main-product-inner").clientHeight){
        document.querySelector(".js-product-nav") ? document.querySelector(".js-product-nav").classList.add("sticky-bar"): '';
      }else{
        document.querySelector(".js-product-nav") ? document.querySelector(".js-product-nav").classList.remove("sticky-bar"): '';
      }
    
      if(document.querySelector(".js-product-nav")){
        let stickyBarHeight = document.querySelector(".js-product-nav").clientHeight;
        let clientHeight = (window.scrollY + stickyBarHeight) + 90;
        // active class in first tab
        clientHeight >= document.querySelector(".main-product-inner").offsetTop &&  clientHeight < document.querySelector(".js-fragrance-triangle-metafields_block").offsetTop ? document.querySelector(".js-scroll-to-frengrence-product-info").classList.add("active") : document.querySelector(".js-scroll-to-frengrence-product-info").classList.remove("active");
        // active class in second tab
        document.querySelector(".js-fregrence-story-scroll-to") ? clientHeight >= document.querySelector(".js-fragrance-triangle-metafields_block").offsetTop && clientHeight < document.querySelector(".js-fregrence-story-scroll-to").offsetTop ? document.querySelector(".js-scroll-to-frengrence-triangle-2").classList.add("active") : document.querySelector(".js-scroll-to-frengrence-triangle-2").classList.remove("active") : clientHeight >= document.querySelector(".js-fragrance-triangle-metafields_block").offsetTop && clientHeight < document.querySelector(".related-products-section").offsetTop ? document.querySelector(".js-scroll-to-frengrence-triangle-2").classList.add("active") : document.querySelector(".js-scroll-to-frengrence-triangle-2").classList.remove("active") ;
        // active class in third tab
        document.querySelector(".js-fregrence-story-scroll-to") ? clientHeight >= document.querySelector(".js-fregrence-story-scroll-to").offsetTop && clientHeight < document.querySelector(".related-products-section").offsetTop ? document.querySelector(".js-fragrance-story-button-2").classList.add("active") : document.querySelector(".js-fragrance-story-button-2").classList.remove("active") : '';
        // active class in forth tab
        clientHeight >= document.querySelector(".related-products-section").offsetTop ? document.querySelector(".js-fragrance-related-button").classList.add("active") : document.querySelector(".js-fragrance-related-button").classList.remove("active");
      }
    
      
    });
    // variable Define
    let scrollToFregrenceTriangleButton = document.querySelector(".js-scroll-to-frengrence-triangle");
    let scrollToFregrenceTriangleButtonSecond = document.querySelector(".js-scroll-to-frengrence-triangle-2");
    let frengranceTriangle = document.querySelector(".js-fragrance-triangle-metafields_block");
    let scrollTpButton = document.querySelector(".js-fragrance-story-button");
    let scrollTpButtonSecond = document.querySelector(".js-fragrance-story-button-2");
    let scrollToDiv = document.querySelector(".js-fregrence-story-scroll-to");
    let scrollToProductButton = document.querySelector(".js-fragrance-related-button");
    let scrollToProductDiv = document.querySelector(".related-products-section");
    let scrollToProductInfoButton = document.querySelector(".js-scroll-to-frengrence-product-info");
    let mainProductSection = document.querySelector("#MainContent");

    // Button click scroll to fragrence triangle
    if (scrollToFregrenceTriangleButton || scrollToFregrenceTriangleButtonSecond) {
        scrollToFregrenceTriangleButton.addEventListener("click", function(event) {
            scrollToFregrenceTriangleButtonSecond.classList.add("active");
            if (scrollTpButtonSecond) {

                scrollTpButtonSecond.classList.remove("active");
            }
            if (scrollToProductInfoButton) {

                scrollToProductInfoButton.classList.remove("active");
            }
            if (scrollToProductButton) {

                scrollToProductButton.classList.remove("active");
            }
            window.scroll({ top: frengranceTriangle.offsetTop - 90, behavior: "smooth", });
        });
        scrollToFregrenceTriangleButtonSecond.addEventListener("click", function(event) {
            scrollToFregrenceTriangleButtonSecond.classList.add("active");
            if (scrollTpButtonSecond) {

                scrollTpButtonSecond.classList.remove("active");
            }
            if (scrollToProductInfoButton) {

                scrollToProductInfoButton.classList.remove("active");
            }
            if (scrollToProductButton) {

                scrollToProductButton.classList.remove("active");
            }
            window.scroll({ top: frengranceTriangle.offsetTop - 90, behavior: "smooth", });
        });
    }

    // story Scroll

    if (scrollTpButton || scrollTpButtonSecond) {
        scrollTpButton.addEventListener("click", function(event) {
            scrollTpButtonSecond.classList.add("active");
            if (scrollToFregrenceTriangleButtonSecond) {

                scrollToFregrenceTriangleButtonSecond.classList.remove("active");
            }
            if (scrollToProductInfoButton) {

                scrollToProductInfoButton.classList.remove("active");
            }
            if (scrollToProductButton) {

                scrollToProductButton.classList.remove("active");
            }
            window.scroll({ top: scrollToDiv.offsetTop, behavior: "smooth", });
        });
        scrollTpButtonSecond ? scrollTpButtonSecond.addEventListener("click", function(event) {
            scrollTpButtonSecond.classList.add("active");
            if (scrollToFregrenceTriangleButtonSecond) {

                scrollToFregrenceTriangleButtonSecond.classList.remove("active");
            }
            if (scrollToProductInfoButton) {

                scrollToProductInfoButton.classList.remove("active");
            }
            if (scrollToProductButton) {

                scrollToProductButton.classList.remove("active");
            }
            
            window.scroll({ top: scrollToDiv.offsetTop, behavior: "smooth", });
        }) : "";
    }

    // related product Scroll

    if (scrollToProductButton) {
        scrollToProductButton.addEventListener("click", function(event) {
            scrollToProductButton.classList.add("active");
            if (scrollTpButtonSecond) {

                scrollTpButtonSecond.classList.remove("active");
            }
            if (scrollToFregrenceTriangleButtonSecond) {

                scrollToFregrenceTriangleButtonSecond.classList.remove("active");
            }
            if (scrollToProductInfoButton) {

                scrollToProductInfoButton.classList.remove("active");
            }
            window.scroll({ top: scrollToProductDiv.offsetTop, behavior: "smooth", });
        });
    }
    // scroll to product info

    if (scrollToProductInfoButton) {
        scrollToProductInfoButton.addEventListener("click", function(event) {
            if (scrollTpButtonSecond) {
                scrollTpButtonSecond.classList.remove("active");
            }
            if (scrollToFregrenceTriangleButtonSecond) {
                scrollToFregrenceTriangleButtonSecond.classList.remove("active");

            }
            if (scrollToProductButton) {

                scrollToProductButton.classList.remove("active");
            }
            scrollToProductInfoButton.classList.add("active");
            window.scroll({ top: mainProductSection.offsetTop - 150, behavior: "smooth", });
        });
    }
  // Travel spray Bundle product delete
  let removeButtons = document.querySelectorAll("custom-remove"); // Adjust the selector as needed
  let cartDrawerRemoveButtons = document.querySelectorAll("custom-remove-drawer");
    if(removeButtons.length > 0){
      removeButtons.forEach((removeButton) => removeButton.addEventListener("click", removeCartProduct.bind(this),false ));
    }
    if(cartDrawerRemoveButtons.length > 0){
      cartDrawerRemoveButtons.forEach((cartDrawerRemoveButton) => cartDrawerRemoveButton.addEventListener("click",cartDrawerRemove.bind(this),false ));
    }
    function removeCartProduct(event){
      let removeButtonProp = event.target.closest(".custom-remove-button").getAttribute("data-bundle-id");
      event.target.closest(".cart_item_info").querySelector(".loading__spinner").classList.remove("hidden");
      let intervalId = setInterval(() => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to fetch cart');
            }
            return response.json();
          })
          .then(cart => {
            console.log(cart)
            let updates = {};
            let hasMainProduct = false;
    
              console.log(removeButtonProp)
            cart.items.forEach(item => {
              console.log(item)
              if (removeButtonProp === item.properties._bundleId ) {
                updates[item.key] = 0;
                hasMainProduct = true;
              }
            console.log(updates)
            });
            if (hasMainProduct) {
             
              return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates: updates })
              });
            } else {
              clearInterval(intervalId);
              
              console.log('All main_product items have been removed');
              window.location.reload();
              return Promise.reject('No items to update');
            }
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to update cart');
            }
            return response.json();
          })
          .then(data => {
            console.log('Cart updated:', data);
            // Uncomment the line below to reload the page after the update
            // window.location.reload();
          })
          .catch(error => {
            if (error !== 'No items to update') {
              console.error('Error:', error);
              alert(`There was an error: ${error.message}. Please try again.`);
              clearInterval(intervalId);
            }
          });
                
      }, 2000);
    }
    function cartDrawerRemove(event){
      let removeButtonProp = event.target.closest("custom-remove-drawer").getAttribute("data-bundle-id");
      event.target.closest(".cart-item").querySelector(".cart-item__totals").classList.remove("visually-hidden");
      event.target.closest(".cart-item").querySelector(".loading__spinner").classList.remove("hidden");
        let intervalId = setInterval(() => {
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => {
              if (!response.ok) {
                throw new Error('Failed to fetch cart');
              }
              return response.json();
            })
            .then(cart => {
              let updates = {};
              let hasMainProduct = false;
      
              cart.items.forEach(item => {
                 if (removeButtonProp === item.properties._bundleId ) {
                  updates[item.key] = 0;
                  hasMainProduct = true;
                }
              });
      
              if (hasMainProduct) {
                return fetch(window.Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ updates: updates })
                });
              } else {
                clearInterval(intervalId);
                console.log('All main_product items have been removed');
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const selectors = ['cart-drawer-items', '.cart-drawer__footer', '#cart-icon-bubble'];
                    for (const selector of selectors) {
                      const targetElement = document.querySelector(selector);
                      const sourceElement = html.querySelector(selector);
                      if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                        
                      }
                  }
                });
                window.location.reload();
                return Promise.reject('No items to update');
              }
            })
            .then(response => {
              if (!response.ok) {
                throw new Error('Failed to update cart');
              }
              return response.json();
            })
            .then(data => {
              console.log('Cart updated:', data);
              // Uncomment the line below to reload the page after the update
              // window.location.reload();
            })
            .catch(error => {
              if (error !== 'No items to update') {
                console.error('Error:', error);
                alert(`There was an error: ${error.message}. Please try again.`);
                clearInterval(intervalId);
              }
            });
                  
        }, 2000); 
    }
  
})();